import { useEffect, useRef, useState } from "react";
//#region src/index.tsx
var useWindowWidth = () => {
	return useDebouncedWindowWidth(0);
};
var useDebouncedWindowWidth = (delay) => {
	const [windowWidth, setWindowWidth] = useState(1024);
	useDebouncedResizeHandler(delay, setWindowWidth);
	return windowWidth;
};
var useDebouncedResizeHandler = (delay, callback) => {
	const timeoutRef = useRef(null);
	useEffect(() => {
		callback(window.innerWidth);
	}, [callback]);
	useEffect(() => {
		const handleResize = () => {
			const timeout = timeoutRef.current;
			if (timeout) clearTimeout(timeout);
			timeoutRef.current = setTimeout(() => {
				callback(window.innerWidth);
			}, delay);
		};
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [delay, callback]);
};
//#endregion
export { useDebouncedResizeHandler, useDebouncedWindowWidth, useWindowWidth };
